class DirectAccessories {
    constructor(container) {
      this.container = container;
      this.productForm = document.querySelector('[data-type="add-to-cart-form"]');
      this.atcButton = this.productForm?.querySelector('[data-action="add-to-cart"]');
      this.priceElement = document.querySelector('.priceItem--regular');
      
      if (!this.productForm || !this.atcButton) return;
  
      // Get data from container attributes
      this.mainProductPrice = parseInt(this.container.dataset.mainPrice) || 0;
      this.currencyFormat = this.container.dataset.currencyFormat || 'dk';
  
      this.init();
    }
  
    init() {
      this.bindCheckboxEvents();
      this.bindAddToCart();
      this.updateTotalPrice(); // Initial calculation
    }
  
    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      const parts = amount.split('.');
      const whole = parts[0];
      const decimal = parts[1];
  
      // Add thousands separator based on format
      if (this.currencyFormat === 'dk' || this.currencyFormat === 'no') {
        // Danish/Norwegian: 2.794,68 kr
        const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return wholeFormatted + ',' + decimal + ' kr';
      } else if (this.currencyFormat === 'bg') {
        // Bulgarian: 2 794,68 лв
        const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return wholeFormatted + ',' + decimal + ' лв';
      } else if (this.currencyFormat === 'tr') {
        // Turkish: 2.794,68 TL
        const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return wholeFormatted + ',' + decimal + ' TL';
      } else {
        // Default fallback
        const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return wholeFormatted + ',' + decimal + ' €';
      }
    }



    updateTotalPrice() {
      if (!this.priceElement) return;
    
      const checkboxes = this.container.querySelectorAll('.direct-accessories__checkbox');
      const infoBadge = document.querySelector('.card-information__accessory-added');
      let accessoriesTotal = 0;
      let checkedCount = 0;
    
      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          accessoriesTotal += parseInt(checkbox.dataset.price) || 0;
          checkedCount++;
        }
      });
    
      const totalPrice = this.mainProductPrice + accessoriesTotal;
      this.priceElement.textContent = this.formatMoney(totalPrice);
    
      // Pill stays visible whenever direct accessories exist on the
      // product (Figma comments #10/#19) — this script only runs on
      // pages that have the accessories container, so always show.
      if (infoBadge) {
        infoBadge.style.display = 'inline-flex';
      }
    
      // Update Add to Cart button text with accessory count
      this.updateButtonText(checkedCount);
    }
    
    updateButtonText(count) {
      // Find the button text element
      const buttonTextEl = this.atcButton.querySelector('span') || this.atcButton;
      
      // Get or store original text
      if (!this.originalButtonText) {
        this.originalButtonText = buttonTextEl.textContent.trim();
      }
    
      // Update button text
      if (count > 0) {
        buttonTextEl.textContent = this.originalButtonText + ' (+' + count + ')';
      } else {
        buttonTextEl.textContent = this.originalButtonText;
      }
    }

    


    // updateTotalPrice() {
    //   if (!this.priceElement) return;
    
    //   const checkboxes = this.container.querySelectorAll('.direct-accessories__checkbox');
    //   const infoBadge = document.querySelector('.card-information__accessory-added');
    //   let accessoriesTotal = 0;
    //   let checkedCount = 0;
    
    //   checkboxes.forEach(checkbox => {
    //     if (checkbox.checked) {
    //       accessoriesTotal += parseInt(checkbox.dataset.price) || 0;
    //       checkedCount++;
    //     }
    //   });
    
    //   const totalPrice = this.mainProductPrice + accessoriesTotal;
    //   this.priceElement.textContent = this.formatMoney(totalPrice);
    
    //   // Show/hide info badge based on checked accessories
    //   if (infoBadge) {
    //     if (checkedCount > 0) {
    //       infoBadge.style.display = 'inline-flex';
    //     } else {
    //       infoBadge.style.display = 'none';
    //     }
    //   }
    // }
  
    // updateTotalPrice() {
    //   if (!this.priceElement) return;
  
    //   const checkboxes = this.container.querySelectorAll('.direct-accessories__checkbox');
    //   let accessoriesTotal = 0;
  
    //   checkboxes.forEach(checkbox => {
    //     if (checkbox.checked) {
    //       accessoriesTotal += parseInt(checkbox.dataset.price) || 0;
    //     }
    //   });
  
    //   const totalPrice = this.mainProductPrice + accessoriesTotal;
    //   this.priceElement.textContent = this.formatMoney(totalPrice);
    // }
  
    bindCheckboxEvents() {
      const checkboxes = this.container.querySelectorAll('.direct-accessories__checkbox');
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => this.updateTotalPrice());
      });
    }
  
    bindAddToCart() {
      this.atcButton.addEventListener('click', async (e) => {
        if (this.atcButton.hasAttribute('data-accessories-added')) {
          this.atcButton.removeAttribute('data-accessories-added');
          return;
        }
  
        const selectedAccessories = this.container.querySelectorAll('.direct-accessories__checkbox:checked');
  
        if (selectedAccessories.length === 0) {
          return;
        }
  
        e.preventDefault();
        e.stopImmediatePropagation();
  
        const accessoryItems = [];
        selectedAccessories.forEach(checkbox => {
          accessoryItems.push({
            id: parseInt(checkbox.dataset.variantId),
            quantity: 1
          });
        });
  
        try {
          const response = await fetch(window.routes.localeRootUrl + '/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ items: accessoryItems })
          });
  
          this.atcButton.setAttribute('data-accessories-added', 'true');
          this.atcButton.click();
  
        } catch (error) {
          console.error('Error adding accessories:', error);
          this.atcButton.setAttribute('data-accessories-added', 'true');
          this.atcButton.click();
        }
  
      }, true);
    }
  }
  
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('[data-direct-accessories]');
    if (container) {
      new DirectAccessories(container);
    }
  });